import { ContainerProps } from '../../interfaces/container.interface'

interface Props extends ContainerProps {
    onSubmit: React.FormEventHandler<HTMLFormElement>
}

const FormComponent = ({ onSubmit, children }: Props) => {
    return (
        <form onSubmit={onSubmit} className='animate__animated animate__fadeInUp animate__delay-2s'>
            {children}
        </form>
    )
}

export default FormComponent
